import type { FaireProductEntity } from "../../entity_types/product";

export const p_263faphxg7: FaireProductEntity = {
  token: "p_263faphxg7",
  type: "product",
  name: "Happy Birthday Greeting Card",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/3af7e55a5d463177e87cb47f9ea274c9807520a83b8a21cbcaf8a2f3ce0f2307.png",
  galleryImageUrls: [],
  priceDollars: 2.75,
  description: "A colorful checkerboard card to say happy birthday!\n\nGood to know: \n\n * Blank on the inside \n * A2 \n * Includes colored envelope \n * Individually wrapped in a cellophane sleeve or plastic free with a removable sticker clasp. \n",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:59.413Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
